import moment from 'moment'

export default {
  filters: {
    formatDate(str, outputFormat = 'DD/MM/YYYY h:mm a') {
      return moment.utc(str).add(moment().utcOffset(), 'm').format(outputFormat)
    }
  }
}
